// extracted by mini-css-extract-plugin
export default {"btnCliente":"documento_btnCliente__-z71B"};